import { useAppSelector } from 'store/hooks';
import { ManageEmailCampaign } from 'features/Marketing/ManageEmailCampaign';

const ManageEmailCampaignPage = () => {
	const { isPunchup } = useAppSelector((state) => state.auth);

	return <ManageEmailCampaign isPunchup={isPunchup} />;
};

export default ManageEmailCampaignPage;
